import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'

import { Typography, TextField, Button } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { duplicateTemplate } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import StyledPaper from '/components/paper'
import HelpText from '/help/template-duplicator'
import Menu from '/components/templates/template-nav-menu'

const TemplateEditor = () => {

  const navigate = useNavigate()
  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => { return templates.filter(t => t.id === templateId)[0] }, [templates, templateId])

  useEffect(() => {
    if (!loadingTemplates && !template) navigate("/templates")
  }, [template])

  return (
    <PageWrapper title="Template Duplicator" HelpText={HelpText} heading={`${template?.name} ${template?.archived ? " [archived]" : ""}`} menu={<Menu template={template} />}>
      <div className='flex flex-col items-center p-5'>
        <Content template={template} />
      </div>
    </PageWrapper>
  )
}

export default TemplateEditor

const Content = ({ template }) => {

  if (template) {
    const navigate = useNavigate()

    const { templateId } = useParams()
    const { apiSource, apiKeys, refreshTemplates, setProcessing } = useContext(AppContext)

    const [newtemplateName, setNewTemplate] = useState("")

    const create = async () => {
      setProcessing(true)
      enqueueSnackbar({ message: 'Creating new template', variant: 'light' })

      const nt = await duplicateTemplate({ apiSource, apiKeys, templateId, newtemplateName })

      if (nt.error) {
        enqueueSnackbar({ message: nt.error, variant: 'error' })
        setProcessing(false)
        // TODO Handle error
      } else {
        enqueueSnackbar({ message: 'Template Created', variant: 'success' })
        setProcessing(false)
        refreshTemplates()
        navigate("../../" + nt.template.id)
      } 
    }

    return (
      <div className='p-20'>

        <StyledPaper>
          <div className='flex flex-col gap-5 p-5'>

            <div className="mb-5">
              <Typography variant='h5'>You are creating a duplicate of : {template.name}</Typography>
            </div>
            <div className="mb-5">
              <Typography variant='h6'>Please choose a name for your new template</Typography>
            </div>

            <div className='flex flex-row gap-5 items-center '>
              <TextField label="New template name (max length 40)"
                className="popupEditorMenuItem"
                value={newtemplateName}
                slotProps={{ inputLabel: { shrink: true } }}
                type="search"
                onChange={e => setNewTemplate(e.target.value.substring(0, 40))}
              />
              <Button onClick={create} disabled={newtemplateName.length < 5}>Create duplicate</Button>
            </div>
          </div>
        </StyledPaper>
      </div>
    )
  }
}